(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupTypeDialogController', FollowupTypeDialogController);

    FollowupTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FollowupType'];

    function FollowupTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FollowupType) {
        var vm = this;
        vm.followupType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:followupTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.followupType.id !== null) {
                FollowupType.update(vm.followupType, onSaveSuccess, onSaveError);
            } else {
                FollowupType.save(vm.followupType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
